<template>
  <div class="role--table">
    <div class="role--table--head">
      <ul>
        <li>
          {{ $t("menu.menuName") }}
        </li>
        <li>{{ $t("menu.menuType") }}</li>
      </ul>
    </div>
    <div class="role--table--body">
      <el-tree
        ref="Tree"
        :data="data"
        :default-checked-keys="defaultCheckedKeys"
        show-checkbox
        node-key="id"
        default-expand-all
        :expand-on-click-node="false"
        @check-change="checkChange"
      >
        <span slot-scope="{ node, data }" class="custom-tree-node">
          <span>{{ node.label }}</span>
          <span>{{ data.type }}</span>
        </span>
      </el-tree>
    </div>
  </div>
</template>

<script>
export default {
  name: "MenuTree",
  props: {
    data: Array,
    defaultCheckedKeys: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      hasChangeCheck: false
    };
  },
  watch: {
    defaultCheckedKeys(oldVal, newVal) {
      this.hasChangeCheck = false;
    }
  },
  mounted() {},
  methods: {
    // 获取选中节点
    getCheckedKeys() {
      return this.$refs.Tree.getCheckedKeys();
    },
    getHalfCheckedKeys() {
      return this.$refs.Tree.getHalfCheckedKeys();
    },
    getCheckChange() {
      return this.hasChangeCheck;
    },
    checkChange() {
      this.hasChangeCheck = true;
    }
  }
};
</script>

<style lang="scss" scoped>
$border-color__ccc: #ccc;
ul,
.role--table--head {
  ul {
    display: flex;
    align-items: center;
    // justify-content: space-between;
    border: 1px solid $border-color__ccc;
    height: 40px;
    background-color: #eaedf3;

    font-size: 14px;
    font-weight: 500;
    text-align: left;
    color: #21252e;
    line-height: 40px;

    li:nth-child(1) {
      padding-left: 10px;
      flex: 1;
    }
    li:nth-child(2) {
      padding-left: 10px;
      border-left: 1px solid $border-color__ccc;
      width: 206px;
    }
  }
}
.custom-tree-node {
  flex: 1;
  min-width: 200px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  span:nth-child(2) {
    display: inline-block;
    width: 200px;
    height: calc(100% + 2px);
    line-height: 40px;
    border-left: 1px solid $border-color__ccc;
    padding-left: 10px;
    text-align: left;
  }
}
::v-deep .el-tree .el-tree-node__content {
  position: relative;
  width: 100%;
  line-height: 28px;
  height: 36px;
  border: 1px solid $border-color__ccc;
  border-top: none;
  &::before {
    content: "";
    width: 30px;
    height: 100%;
  }
}
::v-deep .el-tree .el-checkbox {
  position: absolute;
  left: 10px;
}
::v-deep .el-tree .el-tree-node > .el-tree-node__children {
  overflow: inherit;
}
::v-deep .el-tree .el-tree__empty-block {
  border: 1px solid $border-color__ccc;
  border-top: none;
}
//固定表头
.role--table--body {
  min-width: 100%;
  display: inline-block;
  overflow: auto;
  overflow-y:scroll!important;
  height: 500px;
}
</style>
